import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=31de35fd&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31de35fd')) {
      api.createRecord('31de35fd', component.options)
    } else {
      api.reload('31de35fd', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=31de35fd&", function () {
      api.rerender('31de35fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2My6bZ5o4m28f/JS/cancellationPolicy.vue"
export default component.exports